export default __webpack_public_path__ + "static/media/CNo.72-3.44731cea.jpg";